<template>
    <div class="app">
        <router-view></router-view>
    </div>
</template>

<style>
  @font-face {
        font-family: 'Romul';
        src: url('./fonts/Romul.ttf');
    }
    *,
    *::before,
    *::after{
        box-sizing: border-box;
    }
    *{
        margin: 0;
        padding: 0;
    }
    body{
        font-family: "Bona Nova", serif;
    }
    .container{
        max-width: 1230px;
        width: 100%;
        margin: 0 auto;
        padding-left: 15px;
        padding-right: 15px;
    }
    .header-bg{
        background-color: #fff;
    }
    a, button{
        color: #000;
    }
    input,
    textarea,
    button,
    select,
    a {
        -webkit-tap-highlight-color: transparent;
    }
    button,
    input{
        border: none;
        outline: none;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        /* display: none; <- Crashes Chrome on hover */
        -webkit-appearance: none;
        margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }
    a{
        text-decoration: none;
    }
    button{
        background: none;
        outline: none;
        border: none;
        cursor: pointer;
    }
    .heading{
        font-family: 'Romul';
        font-size: 32px;
        font-weight: 400;
        color: #3A3841;
    }
    .offset{
        margin-bottom: 100px;
    }
    .close{
        position: absolute;
        top: 0;
        right: 0;
        height: 20px;
        width: 20px;
    }
    .close::before{
        position: absolute;
        content: "";
        height: 2px;
        width: 25px;
        background-color: #707070;
        top: 12px;
        right: 0;
        transform: rotate(45deg);
    }
    .close::after{  
        position: absolute;
        content: "";
        height: 2px;
        width: 25px;
        background-color: #707070;
        top: 12px;
        right: 0;
        transform: rotate(-45deg);
    }
    .input{
        width: 100%;
        padding: 13px 20px;
        border-radius: 35px;
        border: 1px solid #000;
        margin-bottom: 25px;
        font-family: 'Bona Nova';
        font-size: 16px;
    }
    .btn{
        font-family: "Bona Nova", serif;
        padding: 20px 30px;
        color: #fff;
        background-color: #3A3841;
        border-radius: 20px;
        font-size: 16px;
    }
    .admBtn{
        font-family: "Bona Nova", serif;
        padding: 10px 15px;
        color: #ECDED3;
        background-color: #3A3841;
        border-radius: 20px;
        font-size: 16px;
        transition: all linear .2s;
        cursor: pointer;
    }
    .admBtn:hover{
        opacity: .5;
    }
    .inactive{
        opacity: .5;
        pointer-events: none;
    }
    @media (max-width: 600px) {
        .container{
            padding-left: 15px;
            padding-right: 15px;
        }
        .offset{
            margin-bottom: 50px;
        }
        .heading{
            font-size: 20px;
        }
    }
</style>
